export default "/public/app-main/static/image/4f99463fc815b7a0a475345f9f2ed150.png";